var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fee-lab-projecao" }, [
    _c(
      "div",
      {
        staticClass:
          "d-flex align-center justify-space-between flex-wrap az-gap-small mb-1"
      },
      [
        _c("div", [
          _c(
            "h3",
            { staticClass: "az-text-primary az-size-14 font-semibold" },
            [_vm._v(" Projeção ano a ano ")]
          ),
          _c("p", { staticClass: "az-text-small ma-0 mt-1" }, [
            _vm._v(_vm._s(_vm.subtitulo))
          ])
        ]),
        _c("BaseToggleButton", {
          attrs: {
            small: "",
            buttonStyle: "flatGray",
            options: _vm.viewOptions
          },
          model: {
            value: _vm.viewMode,
            callback: function($$v) {
              _vm.viewMode = $$v
            },
            expression: "viewMode"
          }
        })
      ],
      1
    ),
    _vm.hasData
      ? _c(
          "div",
          { staticClass: "fee-lab-projecao__canvas mt-4" },
          [
            _c("line-chart", {
              key: _vm.viewMode,
              attrs: {
                "chart-data": _vm.chartData,
                options: _vm.chartOptions,
                styles: _vm.chartStyles
              }
            })
          ],
          1
        )
      : _c("div", { staticClass: "fee-lab-projecao__empty" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }